import React, {useMemo} from 'react';
import { Button, Icons, ListItemText, Menu, MenuItem } from '@curves/ui-base';

import useAnchorMenu from '@Util/hook/useAnchorMenu';
import {isEmpty, isFunction} from '@Util/utils';
import {filterMenu, getOrderMenuMap} from '@Local/Orders/Orders.util';

/**
 * 訂單操作選單組件
 *
 * 功能：
 * - 提供訂單相關的操作選單
 * - 包含折讓、作廢、重新開立發票等操作
 * - 支援條件式顯示操作項目
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.sourceData - 訂單資料
 * @param {Object} props.dialogRef - 彈窗引用
 * @param {Function} props.refresh - 刷新回調
 * @returns {JSX.Element} 訂單操作選單
 */
const OrderActionMenu = ({ className, sourceData, dialogRef, refresh}) => {
    const {anchorEl, open, onOpen, onClose} = useAnchorMenu();
    const menuItems = useMemo(() => filterMenu(getOrderMenuMap({
        orderID: sourceData?.info?.orderID,
        canReview: false,
        canAllowance: sourceData?.canAllowance,
        canInvalid: sourceData?.canInvalid,
        canReissuing: sourceData?.canReissuing,
        }, {
            dialogRef: dialogRef,
            refresh: refresh
        })),
        // eslint-disable-next-line
        [JSON.stringify(sourceData)]);
    if (isEmpty(sourceData) || isEmpty(menuItems)) return null;
    return (
        <>
            <Button className={className} onClick={onOpen} endIcon={<Icons.AngleDown />} variant="outlined" color="secondary">
                操作訂單
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
                {menuItems.map(({ text, onClick, ...rest }, index) => {
                    const handleClick = (e) => {
                        isFunction(onClick) && onClick(e);
                        isFunction(onClose) && onClose(e);
                    };
                    return (
                        <MenuItem key={`menu_item_${index}`} onClick={handleClick} {...rest}>
                            <ListItemText>{text}</ListItemText>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};
export default OrderActionMenu;
